    /**
    * GetCustomerBalanceExResponse entity interface.
    */
    export interface IGetCustomerBalanceExResponse {
    Balance?: number;
    PendingBalance?: number;
    CreditLimit?: number;
    InvoiceAccountBalance?: number;
    InvoiceAccountPendingBalance?: number;
    InvoiceAccountCreditLimit?: number;
    OpenInvoiceBalance?: number;
    OpenInvoiceCount?: number;
    PastDueOpenInvoiceBalance?: number;
    PastDueOpenInvoiceCount?: number;
    CustomerCreditsAvailable?: number;
	  CustName?: string;
    AccountNum?: string;
    }


  /**
   * GetCustomerBalanceExResponse entity class.
   */
  export class GetCustomerBalanceExResponseExtensionClass implements IGetCustomerBalanceExResponse {

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public Balance: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public PendingBalance: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public CreditLimit: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public InvoiceAccountBalance: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public InvoiceAccountPendingBalance: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public InvoiceAccountCreditLimit: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public OpenInvoiceBalance: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public OpenInvoiceCount: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public PastDueOpenInvoiceBalance: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public PastDueOpenInvoiceCount: number;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public CustomerCreditsAvailable: number;

      // Navigation properties names

      /**
       * Construct an object from odata response.
       * @param {any} odataObject The odata result object.
       */
      constructor(odataObject?: any) {
      odataObject = odataObject || {};
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.Balance = (odataObject.Balance) ? parseFloat(odataObject.Balance) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.PendingBalance = (odataObject.PendingBalance) ? parseFloat(odataObject.PendingBalance) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.CreditLimit = (odataObject.CreditLimit) ? parseFloat(odataObject.CreditLimit) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.InvoiceAccountBalance = (odataObject.InvoiceAccountBalance) ? parseFloat(odataObject.InvoiceAccountBalance) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.InvoiceAccountPendingBalance = (odataObject.InvoiceAccountPendingBalance) ? parseFloat(odataObject.InvoiceAccountPendingBalance) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.InvoiceAccountCreditLimit = (odataObject.InvoiceAccountCreditLimit) ? parseFloat(odataObject.InvoiceAccountCreditLimit) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.OpenInvoiceBalance = (odataObject.OpenInvoiceBalance) ? parseFloat(odataObject.OpenInvoiceBalance) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.OpenInvoiceCount = odataObject.OpenInvoiceCount;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.PastDueOpenInvoiceBalance = (odataObject.PastDueOpenInvoiceBalance) ? parseFloat(odataObject.PastDueOpenInvoiceBalance) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.PastDueOpenInvoiceCount = odataObject.PastDueOpenInvoiceCount;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.CustomerCreditsAvailable = (odataObject.CustomerCreditsAvailable) ? parseFloat(odataObject.CustomerCreditsAvailable) : 0;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.CustName = odataObject.CustName;

            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.AccountNum = odataObject.AccountNum;
      }
  }
